import { TypedDocumentNode, gql } from '@apollo/client';

import { ManagerProgressionTaskState } from '@sorare/core/src/__generated__/globalTypes';
import { isType, withFragments } from '@sorare/core/src/gql';

import {
  useComposeTeamOnboardFlow,
  useDisplayOnboardingElements,
} from 'lib/compose-team';

import { useIsExtraSlotDisabled_so5Leaderboard } from './__generated__/useIsExtraSlotDisabled.graphql';

export const useIsExtraSlotDisabled = withFragments(
  (so5Leaderboard: Nullable<useIsExtraSlotDisabled_so5Leaderboard>) => {
    const onboardFlow = useComposeTeamOnboardFlow(so5Leaderboard?.slug);

    const displayOnboardingElements =
      useDisplayOnboardingElements(so5Leaderboard);
    if (!displayOnboardingElements || onboardFlow !== 'f2p') {
      return false;
    }
    return !so5Leaderboard?.tasks?.some(
      task =>
        isType(task, 'ManagerProgressionTask') &&
        task.aasmState === ManagerProgressionTaskState.CLAIMED
    );
  },
  {
    so5Leaderboard: gql`
      fragment useIsExtraSlotDisabled_so5Leaderboard on So5Leaderboard {
        slug
        tasks {
          ... on ManagerProgressionMission {
            id
          }
          ... on ManagerProgressionTask {
            id
            aasmState
            probabilisticBundles {
              id
              opened
            }
          }
        }
        ...useDisplayOnboardingElements_so5Leaderboard
      }
      ${useDisplayOnboardingElements.fragments.so5Leaderboard}
    ` as TypedDocumentNode<useIsExtraSlotDisabled_so5Leaderboard>,
  }
);
